import { FC } from 'react'
import priceFormatter from '../../utils/priceFormatter'
import arrayToNodeString from '../../utils/arrayToNodeString'
import { IOrderItem } from '../../model/IOrder'
import { icons } from '../../icons/IconSet'
import PartscareBadge from './PartscareBadge'

type TOrderItemSize = 'small' | 'medium' | 'large'

const OrderItem: FC<
  IOrderItem & {
    isSelected?: boolean
    select?: () => unknown
    size?: TOrderItemSize
    /** Off inside the return and claim forms, where an upsell does not belong. */
    showPartscare?: boolean
  }
> = ({
  partTypeCode,
  name,
  viYear,
  viModel,
  viMake,
  pid,
  price,
  partscare,
  isSelected,
  select,
  size = 'large',
  showPartscare = true,
}) => {
  const scale: Record<
    TOrderItemSize,
    {
      className: string
      imgW: number
      gap: number
    }
  > = {
    // 'large' is the order list, where the card now spans the full width freed up
    // by removing the action buttons. The claim forms keep the narrow card.
    small: { className: 'lg:w-[466px]', imgW: 100, gap: 0 },
    medium: { className: 'lg:w-[466px]', imgW: 115, gap: 0 },
    large: { className: 'w-full', imgW: 150, gap: 2 },
  }

  return (
    <div
      onClick={() => select && select()}
      className={`
        flex flex-col border-[4px] rounded-md p-2 transition-all duration-400
        ${
          isSelected
            ? 'border-primary_hover hover:cursor-text hover:border-primary_hover shadow-md'
            : 'border-white hover:border-border_color opacity-70 hover:opacity-100'
        }
        ${select ? 'hover:border-primary_hover cursor-pointer' : ''}
        ${scale[size].className}
      `}
    >
      {/* Part on the left, PartsCare badge on the right; stacked on narrow screens. */}
      <div className='flex flex-col sm:flex-row gap-4 sm:justify-between'>
        <div className='flex gap-4'>
          <div className=''>
            {!!partTypeCode ? (
              <img
                src={`https://automotix.net/images/products_small/lkq/${partTypeCode.toLowerCase()}_category.jpg`}
                width={scale[size].imgW}
                height={scale[size].imgW}
                alt={`${name || ''} for ${viYear || ''} ${viMake || ''} ${viModel || ''}`}
              />
            ) : (
              <div
                style={{
                  width: scale[size].imgW,
                  height: scale[size].imgW,
                }}
                className='flex justify-center items-center bg-slate-200'
              >
                {icons('package', { width: `${scale[size].imgW * 0.75}px`, stroke: 'white' })}
              </div>
            )}
          </div>
          <div
            style={{
              gap: scale[size].gap,
              paddingTop: scale[size].gap * 4,
            }}
            className='flex flex-col'
          >
            <div className='font-bold'>{arrayToNodeString(' ', [viYear, viMake, name])}</div>
            <div className=''>{viModel || ''}</div>
            <div className='text-red-600 font-bold'>{name}</div>
            <div className=''>Part#: {pid}</div>
            <div className='text-md font-bold mt-2'>{priceFormatter(price)}</div>
          </div>
        </div>
        {showPartscare ? <PartscareBadge partscare={partscare} /> : null}
      </div>
    </div>
  )
}

export default OrderItem
